export function Pagination({
  page,
  pageSize,
  total,
  onPage,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const first = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);

  return (
    <div className="pagination">
      <span>
        {total === 0
          ? 'Aucun résultat'
          : `${first} – ${last} sur ${total}`}
      </span>
      <span className="pousse">
        Page {page} / {pages}
      </span>
      <button
        type="button"
        className="bouton bouton--petit"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        Précédent
      </button>
      <button
        type="button"
        className="bouton bouton--petit"
        disabled={page >= pages}
        onClick={() => onPage(page + 1)}
      >
        Suivant
      </button>
    </div>
  );
}
